// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  Analytics,
  tracingCallback,
  formatContainers,
} from '@trello/atlassian-analytics';
import { Auth } from 'app/scripts/db/Auth';
import { MemberBoardProfileView } from 'app/scripts/views/member/MemberBoardProfileView';
import { Dialog } from 'app/scripts/views/lib/Dialog';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { MemberOnBoardView } from 'app/scripts/views/member-menu-profile/MemberOnBoardView';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { BoardHeaderAllMembersView } from 'app/scripts/views/board/BoardHeaderAllMembersView';
import { maybeDisplayMemberLimitsError } from 'app/scripts/views/board-menu/MemberLimitsError';
import {
  LazyBoardInviteModal,
  dialogProps,
} from 'app/src/components/BoardInviteModal';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const MAX_FACEPILE_SIZE = 5;

export const onMemberAdd = function () {
  return this.renderBoardHeaderFacepileDebounced();
};

export const renderBoardHeaderFacepile = function () {
  // eslint-disable-next-line @trello/enforce-variable-case
  const $target = $('.js-fill-facepile', this.$el);
  let visibleMembers = this.model.orderedVisibleMembers();
  const numMembers = visibleMembers.length;
  visibleMembers = visibleMembers.slice(0, MAX_FACEPILE_SIZE);
  const overflowMemberCount = numMembers - MAX_FACEPILE_SIZE;

  if (overflowMemberCount > 0) {
    $('.js-fill-board-member-count', this.$el).text(`+${overflowMemberCount}`);
  } else {
    $('.js-fill-board-member-count', this.$el).text('');
  }

  let z = visibleMembers.length;
  const subviews = visibleMembers.map((member) =>
    this.subview(MemberOnBoardView, member, { board: this.model, zIndex: z-- }),
  );

  if ($target.length > 0) {
    this.ensureSubviews(subviews, $target);
  }

  this.defer(() => {
    // Disallow adding members to cards from facepile when board is in template mode
    if (!this.model.isTemplate()) {
      DragSort.refreshDraggableBoardMembers();
    }
  });

  return this;
};

export const openAllMembers = function (e) {
  // activated only when there's member overflow from facepile
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'allBoardMembersButton',
    source: 'boardScreen',
  });

  return PopOver.toggle({
    elem: $('.js-open-show-all-board-members', this.$el),
    view: BoardHeaderAllMembersView,
    options: {
      model: this.model,
      modelCache: this.modelCache,
    },
  });
};

export const openAddMembers = function (e) {
  if (e) {
    stopPropagationAndPreventDefault(e);
  }

  const idOrganization = this.model.getOrganization()?.id;
  Analytics.sendClickedButtonEvent({
    buttonName: 'shareButton',
    source: 'boardScreen',
    containers: formatContainers({
      idBoard: this.model.id,
      idOrganization,
      idWorkspace: idOrganization,
    }),
  });

  Dialog.show({
    reactElement: (
      <ComponentWrapper>
        <LazyBoardInviteModal
          idBoard={this.model.id}
          idOrg={idOrganization}
          onClose={Dialog.hide}
        />
      </ComponentWrapper>
    ),
    ...dialogProps,
  });
};

export const joinBoard = function (e) {
  stopPropagationAndPreventDefault(e);

  Analytics.sendClickedButtonEvent({
    buttonName: 'joinBoardButtonV2',
    source: 'boardScreen',
  });

  if (maybeDisplayMemberLimitsError($(e.target), this.model, Auth.me())) {
    return;
  }

  const traceId = Analytics.startTask({
    taskName: 'edit-board/members/join',
    source: 'boardScreen',
  });

  $('.js-join-board', this.$el).remove();

  this.model.joinBoard(
    traceId,
    tracingCallback(
      {
        taskName: 'edit-board/members/join',
        source: 'boardScreen',
        traceId,
      },
      (error, response) => {
        if (response) {
          Analytics.sendTrackEvent({
            action: 'joined',
            actionSubject: 'board',
            source: 'boardScreen',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
            },
            attributes: {
              taskId: traceId,
            },
          });
        }
      },
    ),
  );
};

export const showMemberProfile = function (member) {
  Controller.saveMemberBoardProfileLocation(member, this.model.id);
  if (!Dialog.isVisible) {
    Dialog.show({
      view: new MemberBoardProfileView({
        model: member,
        board: this.model,
        modelCache: this.modelCache,
      }),
      maxWidth: 500,
      hide: () => Controller.setBoardLocation(this.model.id),
    });
  }
};
